import { render, staticRenderFns } from "./activities-overview.vue?vue&type=template&id=1a6c4ef5&"
import script from "./activities-overview.vue?vue&type=script&lang=js&"
export * from "./activities-overview.vue?vue&type=script&lang=js&"
import style0 from "./activities-overview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports